var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-Rides-1",
    transform: "translate(-1378.000000, -70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_profile-copy",
    transform: "translate(1375.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.99,12.29 C9.34455605,12.29 7.2,10.145444 7.2,7.5 C7.2,4.85455605 9.34455605,2.71 11.99,2.71 C14.635444,2.71 16.78,4.85455605 16.78,7.5 C16.78,10.145444 14.635444,12.29 11.99,12.29 Z M11.99,10.29 C13.5308745,10.29 14.78,9.04087445 14.78,7.5 C14.78,5.95912555 13.5308745,4.71 11.99,4.71 C10.4491255,4.71 9.2,5.95912555 9.2,7.5 C9.2,9.04087445 10.4491255,10.29 11.99,10.29 Z",
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41925359,19.3145117 L3.52074641,18.6854883 L4.62090555,15.3650084 C5.02668066,14.1423761 6.1677071,13.3152829 7.46,13.31 L16.5090918,13.3100004 C17.802815,13.3088255 18.9515694,14.1371378 19.3592536,15.3654883 L20.4592536,18.6854883 L18.5607464,19.3145117 L17.4609082,15.9949996 C17.3250674,15.5857121 16.9421493,15.3096079 16.51,15.31 L7.46409445,15.3099916 C7.03469497,15.3117498 6.65435282,15.5874475 6.51925359,15.9945117 L5.41925359,19.3145117 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProfile);
export default __webpack_public_path__ + "static/media/ico_profile.2f4243385390145eed66c32032b1f1b9.svg";
export { ForwardRef as ReactComponent };